// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yg81","option":"styles_option__1NXID","active":"styles_active__70j_r"};